/**
 * validates values with given rules
 * @param {Object} values - values to validate
 * @param {Object} props - component props
 * @param {Object[]} rules
 * @returns {*}
 */
function validate(values, props, rules) {
  const valuesKeys = Object.keys(rules);

  return valuesKeys.reduce((errors, k) => {
    const validations = rules[k];
    if (!validations) {
      return errors;
    }
    const value = values[k];
    validations.every((validation) => {
      if (!validation.validate(value, values, props)) {
        // eslint-disable-next-line no-param-reassign
        errors[k] =
          typeof validation.msg === 'function'
            ? validation.msg(value, values, props)
            : validation.msg;

        return false;
      }

      return true;
    });

    return errors;
  }, {});
}

/**
 * @param {Object[]} rules
 */
export default (rules) =>
  (values, props = {}) =>
    validate(values, props, rules);
